module.exports = __webpack_public_path__ + "img/logo.f5b7402f.png";